import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IListOfCardsByBrokenRuleFilterFormMeta {
    ruleId: FormInputMeta;
    ruleLabel: FormInputMeta;
    dateType: FormInputMeta;
    startDate: FormInputMeta;
    endDate: FormInputMeta;

    schema: any;
}

const listOfCardsByBrokenRuleFilterFormMeta = {} as IListOfCardsByBrokenRuleFilterFormMeta;

listOfCardsByBrokenRuleFilterFormMeta.ruleId = {
    name: "ruleId",
    type: "text",
    label: "Id Règle",
    placeholder: "Id Règle",
    validation: yup.string(),
};

listOfCardsByBrokenRuleFilterFormMeta.ruleLabel = {
    name: "ruleLabel",
    type: "text",
    label: "Libellé Règle",
    placeholder: "Libellé Règle",
    validation: yup.string(),
};

listOfCardsByBrokenRuleFilterFormMeta.dateType = {
    name: "dateType",
    type: "text",
    label: "Type Date",
    placeholder: "Type Date",
    validation: yup.string(),
};

listOfCardsByBrokenRuleFilterFormMeta.startDate = {
    name: "startDate",
    type: "date",
    label: "Date Début",
    placeholder: "Date Début",
    validation: yup.date(),
};

listOfCardsByBrokenRuleFilterFormMeta.endDate = {
    name: "endDate",
    type: "date",
    label: "Date Fin",
    placeholder: "Date Fin",
    validation: yup.date(),
};


listOfCardsByBrokenRuleFilterFormMeta.schema = yup.object().shape(getValidationSchema(listOfCardsByBrokenRuleFilterFormMeta));

export default listOfCardsByBrokenRuleFilterFormMeta;